/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

/**
 *
 *
 * 0 = Unknown
 *
 * 1 = WorkRequired
 *
 * 2 = OkToUse
 *
 * 3 = WorkInProgress
 *
 * 4 = CollectionBooked
 *
 * 5 = Collected
 *
 * 6 = ToReturn
 *
 * 7 = GetReadyForSales
 *
 * 8 = RepairCompleted
 */
export enum VehicleInspectionStatus {
  Unknown = 0,
  WorkRequired = 1,
  OkToUse = 2,
  WorkInProgress = 3,
  CollectionBooked = 4,
  Collected = 5,
  ToReturn = 6,
  GetReadyForSales = 7,
  RepairCompleted = 8,
}
